import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    nationalLogisticsPlan: {
        id: 'iaso.polio.nationalLogisticsPlan',
        defaultMessage: 'National Logistics Plan',
    },
    country: {
        id: 'iaso.polio.table.label.country',
        defaultMessage: 'Country',
    },
    countryBlock: {
        defaultMessage: 'Country block',
        id: 'iaso.polio.label.countryBlock',
    },
    date: {
        id: 'iaso.polio.form.label.date',
        defaultMessage: 'Date',
    },
    status: {
        id: 'iaso.polio.table.label.status',
        defaultMessage: 'Status',
    },
    antigen: {
        id: 'iaso.polio.antigen',
        defaultMessage: 'Vaccine',
    },
    createdAt: {
        id: 'iaso.forms.created_at',
        defaultMessage: 'Created',
    },
    updatedAt: {
        id: 'iaso.forms.updated_at',
        defaultMessage: 'Updated',
    },
    actions: {
        id: 'iaso.label.actions',
        defaultMessage: 'Action(s)',
    },
    edit: {
        id: 'iaso.label.edit',
        defaultMessage: 'Edit',
    },
    deleteNationalLogisticsPlan: {
        id: 'iaso.polio.nationalLogisticsPlan.delete',
        defaultMessage: 'Delete National Logistic Plan Data: {name}',
    },
    deleteNationalLogisticsPlanWarning: {
        id: 'iaso.polio.nationalLogisticsPlan.deleteWarning',
        defaultMessage: 'Are you sure you want to delete this entry?',
    },
    invalidDate: {
        id: 'iaso.polio.validation.invalidDate',
        defaultMessage: 'Invalid date',
    },
    requiredField: {
        id: 'iaso.polio.validation.fieldRequired',
        defaultMessage: 'This field is required',
    },
    editNationalLogisticsPlan: {
        id: 'iaso.polio.nationalLogisticsPlan.edit',
        defaultMessage: 'Edit National Logistics Plan',
    },
    addNationalLogisticsPlan: {
        id: 'iaso.polio.nationalLogisticsPlan.add',
        defaultMessage: 'Add National Logistics Plan',
    },
    confirm: {
        id: 'iaso.label.confirm',
        defaultMessage: 'Confirm',
    },
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    yes: {
        id: 'iaso.label.yes',
        defaultMessage: 'Yes',
    },
    no: {
        id: 'iaso.label.no',
        defaultMessage: 'No',
    },
    draft: {
        id: 'iaso.polio.nationalLogisticsPlan.status.draft',
        defaultMessage: 'Draft',
    },
    commented: {
        id: 'iaso.polio.nationalLogisticsPlan.status.commented',
        defaultMessage: 'Commented',
    },
    final: {
        id: 'iaso.polio.nationalLogisticsPlan.status.final',
        defaultMessage: 'Final',
    },
    deleteText: {
        id: 'iaso.label.deleteText',
        defaultMessage: 'This operation cannot be undone.',
    },
    latestPhysicalInventory: {
        id: 'iaso.polio.label.latestPhysicalInventory',
        defaultMessage: 'Latest physical inventory',
    },
});

export default MESSAGES;
